var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-40 py-10", attrs: { id: "profile" } },
    [
      _c(
        "div",
        { staticClass: "mb-6" },
        [
          _c("BlTextTitle4", { attrs: { text: "Profile" } }),
          _vm._v(" "),
          _c("BlTextBody2", {
            attrs: {
              text:
                "Personalize your account by updating your profile information."
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-6 flex justify-center items-center flex-col" },
        [
          _c("Avatar", {
            staticClass: "bg-error",
            attrs: { name: _vm.initial, size: 150, square: "", status: "" }
          }),
          _vm._v(" "),
          _c("BlInputButton", {
            staticClass: "hidden",
            staticStyle: { width: "150px" },
            attrs: { label: "Upload Photo", type: "plain" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-6" },
        [
          _c("BlInputText", {
            attrs: { input: _vm.nameInput },
            on: { changed: _vm.inputNameHandler }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mb-6" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-between border-b border-grey-200 py-4"
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("BlTextBody1", { attrs: { text: "Role" } }),
                _vm._v(" "),
                _c("BlIcon", {
                  staticClass: "h-6 w-6",
                  attrs: {
                    icon: "toast-info",
                    tooltip: "To change your role, please contact your admin."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex items-center gap-2" }, [
              _c(
                "div",
                {
                  staticClass: "py-1 px-3 flex items-center rounded",
                  class: {
                    "bg-cornflower-700": _vm.currentUserRole === "admin",
                    "bg-lime-700": _vm.currentUserRole === "staff",
                    "bg-orange-700": _vm.currentUserRole === "super_admin"
                  }
                },
                [
                  _c("BlTextBody2", {
                    staticClass: "text-pure-white",
                    attrs: { text: _vm.userRoles[_vm.currentUserRole] }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentUser.is_owner
                ? _c(
                    "div",
                    {
                      staticClass:
                        "py-1 px-3 flex items-center rounded bg-dark-purple-100"
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-pure-white",
                        attrs: { text: "Owner" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "w-full flex items-center justify-between border-b border-grey-200 py-4"
          },
          [
            _c("BlTextBody1", { attrs: { text: "Email" } }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "flex items-center gap-2 flex-shrink-0 outline-none",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.emailOpened = true
                  }
                }
              },
              [
                _c("BlTextBody1", {
                  staticClass: "text-grey-400",
                  attrs: { text: _vm.currentUser.email }
                }),
                _vm._v(" "),
                _c("BlIcon", {
                  staticClass: "h-6 w-6",
                  attrs: { icon: "chevron-right" }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "w-full flex items-center justify-between border-b border-grey-200 py-4"
          },
          [
            _c("BlTextBody1", { attrs: { text: "Change Password" } }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "flex items-center flex-shrink-0 outline-none",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.changePasswordOpened = true
                  }
                }
              },
              [
                _c("BlIcon", {
                  staticClass: "h-6 w-6",
                  attrs: { icon: "chevron-right" }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.emailOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: !_vm.verified
                  ? "Verify your password"
                  : "Change your email",
                description: !_vm.verified
                  ? "For security purposes, please verify your password before changing your email address."
                  : "Please make sure your new email address is active and accessible before updating your email information.",
                label: !_vm.verified ? "Continue" : "Update",
                disabled: !_vm.verified
                  ? !_vm.verifyInput.model
                  : !_vm.emailInput.model
              },
              on: {
                "backdrop-close": _vm.closeBackdrop,
                "backdrop-action": function($event) {
                  !_vm.verified ? _vm.verifyPassword() : _vm.saveEmail()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "px-8" },
                [
                  !_vm.verified
                    ? _c("BlInputText", {
                        attrs: { input: _vm.verifyInput },
                        on: { changed: _vm.inputHandler }
                      })
                    : _c(
                        "div",
                        [
                          _c("BlInputText", {
                            staticClass: "mb-4",
                            attrs: {
                              input: {
                                label: "Previous email address",
                                model: _vm.currentUser.email,
                                disabled: true,
                                readonly: true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputText", {
                            attrs: { input: _vm.emailInput },
                            on: { changed: _vm.inputHandler }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.changePasswordOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Change your password",
                description:
                  "Protect your account with a stronger password. Please enter your current and new password to keep your personal information secure.",
                label: "Update",
                disabled: !_vm.verifyInput.model || !_vm.passwordInput.model
              },
              on: {
                "backdrop-close": _vm.closeBackdrop,
                "backdrop-action": _vm.savePassword
              }
            },
            [
              _c(
                "div",
                { staticClass: "px-8" },
                [
                  _c("BlInputText", {
                    staticClass: "mb-4",
                    attrs: { input: _vm.verifyInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c("BlInputText", {
                    staticClass: "mb-4",
                    attrs: { input: _vm.passwordInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid grid-cols-3 mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "rounded-full w-6 h-6",
                          class: _vm.passwordHasSixChar
                            ? "bg-success-400"
                            : _vm.passwordInputChecked
                            ? "bg-error-300 p-1"
                            : "bg-grey-300",
                          attrs: {
                            icon:
                              _vm.passwordInputChecked &&
                              !_vm.passwordHasSixChar
                                ? "close"
                                : "check",
                            color: "secondary"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-xs" }, [
                          _vm._v("6 characters minimum")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "rounded-full w-6 h-6",
                          class: _vm.passwordHasUppercase
                            ? "bg-success-400"
                            : _vm.passwordInputChecked
                            ? "bg-error-300 p-1"
                            : "bg-grey-300",
                          attrs: {
                            icon:
                              _vm.passwordInputChecked &&
                              !_vm.passwordHasUppercase
                                ? "close"
                                : "check",
                            color: "secondary"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-xs" }, [
                          _vm._v("1 uppercase character")
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid grid-cols-3" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "rounded-full w-6 h-6",
                          class: _vm.passwordHasLowescase
                            ? "bg-success-400"
                            : _vm.passwordInputChecked
                            ? "bg-error-300 p-1"
                            : "bg-grey-300",
                          attrs: {
                            icon:
                              _vm.passwordInputChecked &&
                              !_vm.passwordHasLowescase
                                ? "close"
                                : "check",
                            color: "secondary"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-xs" }, [
                          _vm._v("1 lowercase character")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "rounded-full w-6 h-6",
                          class: _vm.passwordHasNumber
                            ? "bg-success-400"
                            : _vm.passwordInputChecked
                            ? "bg-error-300 p-1"
                            : "bg-grey-300",
                          attrs: {
                            icon:
                              _vm.passwordInputChecked && !_vm.passwordHasNumber
                                ? "close"
                                : "check",
                            color: "secondary"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-xs" }, [
                          _vm._v("1 number")
                        ])
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16c46cac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16c46cac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/TabProfile.vue
// module id = null
// module chunks = 